import { INITIAL_STATE_FIELD, StateField, StateFieldType } from '@navstation-portal/reporting/data-model/vessel-report';

export const initStateField = <T>(value?: T): StateField<T | undefined> => ({
  value,
  ...INITIAL_STATE_FIELD,
});

export type BuiltFormSection<T extends Record<string, StateFieldType>> = {
  [K in keyof T]-?: StateField<T[K] | undefined>;
};

export function buildFormSection<T extends Record<string, StateFieldType>>(source: T | undefined): BuiltFormSection<T> {
  const result = {} as BuiltFormSection<T>;
  if (!source) return result;

  for (const key in source) {
    // Key must match field name in source
    const typedKey = key as keyof T;
    result[typedKey] = initStateField(source[typedKey]);
  }

  return result;
}
